"use strict";

var _regeneratorRuntime = require("/root/ui-api/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.values.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.function.name.js");

var _promisify = require("../promisify");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e3) {
      didErr = true;
      err = _e3;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var bigi = require('bigi'),
    bs58 = require('bs58'),
    ecurve = require('ecurve'),
    Point = ecurve.Point,
    secp256k1 = ecurve.getCurveByName('secp256k1'),
    config = require('../config'),
    operations = require('./serializer/src/operations'),
    Signature = require('./ecc/src/signature'),
    PrivateKey = require('./ecc/src/key_private'),
    PublicKey = require('./ecc/src/key_public'),
    session = require('./session'),
    multiSession = require('./multiSession'),
    golosApi = require('../api'),
    hash = require('./ecc/src/hash');

var Auth = {};
var transaction = operations.transaction;
var signed_transaction = operations.signed_transaction;

Auth.verify = function (name, password, auths) {
  var hasKey = false;
  var roles = [];

  for (var role in auths) {
    roles.push(role);
  }

  var pubKeys = this.generateKeys(name, password, roles);
  roles.forEach(function (role) {
    if (auths[role][0][0] === pubKeys[role]) {
      hasKey = true;
    }
  });
  return hasKey;
};

Auth.generateKeys = function (name, password, roles) {
  var pubKeys = {};
  roles.forEach(function (role) {
    var seed = name + role + password;
    var brainKey = seed.trim().split(/[\t\n\v\f\r ]+/).join(' ');
    var hashSha256 = hash.sha256(brainKey);
    var bigInt = bigi.fromBuffer(hashSha256);
    var toPubKey = secp256k1.G.multiply(bigInt);
    var point = new Point(toPubKey.curve, toPubKey.x, toPubKey.y, toPubKey.z);
    var pubBuf = point.getEncoded(toPubKey.compressed);
    var checksum = hash.ripemd160(pubBuf);
    var addy = Buffer.concat([pubBuf, checksum.slice(0, 4)]);
    pubKeys[role] = config.get('address_prefix') + bs58.encode(addy);
  });
  return pubKeys;
};
/**
    @arg {string} name - blockchain account name
    @arg {string} password - very strong password typically no shorter than a private key
    @arg {array} roles - defaults to standard Golos blockchain-level roles
*/


Auth.getPrivateKeys = function (name, password) {
  var roles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['owner', 'active', 'posting', 'memo'];
  var privKeys = {};
  roles.forEach(function (role) {
    privKeys[role] = this.toWif(name, password, role);
    privKeys[role + 'Pubkey'] = this.wifToPublic(privKeys[role]);
  }.bind(this));
  return privKeys;
};

Auth.isWif = function (privWif) {
  var isWif = false;

  try {
    var bufWif = new Buffer(bs58.decode(privWif));
    var privKey = bufWif.slice(0, -4);
    var checksum = bufWif.slice(-4);
    var newChecksum = hash.sha256(privKey);
    newChecksum = hash.sha256(newChecksum);
    newChecksum = newChecksum.slice(0, 4);

    if (checksum.toString() == newChecksum.toString()) {
      isWif = true;
    }
  } catch (e) {}

  return isWif;
};

Auth.loginAsync = function (name, password, callback) {
  var _this = this;

  try {
    var result = {
      owner: null,
      active: null,
      posting: null,
      memo: null,
      password: null
    };
    var roles = Object.keys(result).slice(0, 4);
    var privateKeys = {};
    var isPass = false;

    try {
      var pk = PrivateKey.fromWif(password);
      roles.map(function (role) {
        return privateKeys[role] = pk.toString();
      });
    } catch (err) {
      isPass = true;
      roles.map(function (role) {
        return privateKeys[role] = PrivateKey.fromSeed("".concat(name).concat(role).concat(password)).toString();
      });
    }

    golosApi.getAccounts([name], function (err, res) {
      if (err) {
        callback(err, null);
        return;
      }

      if (res.length == 0) {
        callback('No such account', null);
        return;
      }

      if (res[0].frozen) {
        callback('Account is frozen', null);
        return;
      }

      roles.slice(0, 3).map(function (role) {
        var key_auths = res[0][role].key_auths;

        for (var i = 0; i < key_auths.length; i++) {
          if (_this.wifIsValid(privateKeys[role], key_auths[i][0])) {
            result[role] = privateKeys[role];
            break;
          }
        }
      });
      if (_this.wifIsValid(privateKeys.memo, res[0].memo_key)) result.memo = privateKeys.memo;
      if (isPass && result.posting) result.password = password;
      callback(null, result);
    });
  } catch (err) {
    callback(err, null);
  }
};

Auth.login = (0, _promisify.promisify)(Auth.loginAsync); // `keys` is object like:
// { posting: "private posting key" }

Auth.withNodeLogin =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var account, keys, call, dgp, api, sessionName, resp, MultiSession, ms, sessionData, loginData, _resp, gprops, _gprops, head_block_number, witness, signed, signature;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            account = _ref.account, keys = _ref.keys, call = _ref.call, dgp = _ref.dgp, api = _ref.api, sessionName = _ref.sessionName;
            if (!sessionName) sessionName = 'node_login';

            if (!api) {
              api = golosApi;
            }

            MultiSession = multiSession.MultiSession;
            ms = new MultiSession(sessionName);
            sessionData = ms.load();
            loginData = sessionData.getVal(account, 'login_data');

            if (!loginData) {
              _context.next = 13;
              break;
            }

            _context.next = 10;
            return call(loginData);

          case 10:
            _resp = _context.sent;

            if (_resp.login_error) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", _resp);

          case 13:
            if (dgp) {
              _context.next = 19;
              break;
            }

            _context.next = 16;
            return api.getDynamicGlobalPropertiesAsync();

          case 16:
            gprops = _context.sent;
            _context.next = 26;
            break;

          case 19:
            if (!(typeof dgp === 'function')) {
              _context.next = 25;
              break;
            }

            _context.next = 22;
            return dgp();

          case 22:
            gprops = _context.sent;
            _context.next = 26;
            break;

          case 25:
            gprops = dgp;

          case 26:
            _gprops = gprops, head_block_number = _gprops.head_block_number, witness = _gprops.witness;
            console.time('withNodeLogin - signData');
            signed = this.signData(head_block_number.toString(), keys);
            console.timeEnd('withNodeLogin - signData'); // TODO: only 1st, because node supports only 1 key

            signature = Object.values(signed)[0];
            loginData = {
              account: account,
              signed_data: {
                head_block_number: head_block_number,
                witness: witness
              },
              signature: signature
            };
            _context.next = 34;
            return call(loginData);

          case 34:
            resp = _context.sent;

            if (!resp.login_error) {
              _context.next = 37;
              break;
            }

            throw resp.login_error;

          case 37:
            sessionData.setVal(account, 'login_data', loginData).save();
            return _context.abrupt("return", resp);

          case 39:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

Auth.toWif = function (name, password, role) {
  var seed = name + role + password;
  var brainKey = seed.trim().split(/[\t\n\v\f\r ]+/).join(' ');
  var hashSha256 = hash.sha256(brainKey);
  var privKey = Buffer.concat([new Buffer([0x80]), hashSha256]);
  var checksum = hash.sha256(privKey);
  checksum = hash.sha256(checksum);
  checksum = checksum.slice(0, 4);
  var privWif = Buffer.concat([privKey, checksum]);
  return bs58.encode(privWif);
};

Auth.wifIsValid = function (privWif, pubWif) {
  return this.wifToPublic(privWif) == pubWif;
};

Auth.wifToPublic = function (privWif) {
  var pubWif = PrivateKey.fromWif(privWif);
  pubWif = pubWif.toPublic().toString();
  return pubWif;
};

Auth.isPubkey = function (pubkey, address_prefix) {
  return PublicKey.fromString(pubkey, address_prefix) != null;
};

Auth.signTransaction = function (trx, keys) {
  var signatures = [];

  if (trx.signatures) {
    signatures = [].concat(trx.signatures);
  }

  var cid = new Buffer(config.get('chain_id'), 'hex');
  var buf = transaction.toBuffer(trx);

  for (var key in keys) {
    var sig = Signature.signBuffer(Buffer.concat([cid, buf]), keys[key]);
    signatures.push(sig.toBuffer());
  }

  return signed_transaction.toObject(Object.assign(trx, {
    signatures: signatures
  }));
};

Auth.signData = function (data, keys) {
  var signatures = {};
  var bufSha = hash.sha256(data);

  var sign = function sign(role, d) {
    if (!d) return;
    var sig = Signature.signBufferSha256(bufSha, d);
    signatures[role] = sig.toHex();
  };

  for (var key in keys) {
    sign(key, keys[key]);
  }

  return signatures;
};

Auth.verifySignedData = function (data, signatures, account, authTypes) {
  var auth = {};
  var bufSha = hash.sha256(data);

  var verify = function verify(type, sigHex, pubkey, weight, weight_threshold) {
    if (!sigHex) return;

    if (weight !== 1 || weight_threshold !== 1) {
      console.error("Auth.verifySignedData unsupported ".concat(type, " auth configuration: ").concat(account.name));
    } else {
      var parseSig = function parseSig(hexSig) {
        try {
          return Signature.fromHex(hexSig);
        } catch (e) {
          return null;
        }
      };

      var sig = parseSig(sigHex);
      var public_key = PublicKey.fromString(pubkey);
      var verified = sig.verifyHash(bufSha, public_key);
      auth[type] = verified;
    }
  };

  var _iterator = _createForOfIteratorHelper(authTypes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var authType = _step.value;
      var _account$authType = account[authType],
          key_auths = _account$authType.key_auths,
          weight_threshold = _account$authType.weight_threshold;

      var _key_auths = _slicedToArray(key_auths, 1),
          _key_auths$ = _slicedToArray(_key_auths[0], 2),
          pubKey = _key_auths$[0],
          weight = _key_auths$[1];

      verify(authType, signatures[authType], pubKey, weight, weight_threshold);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return auth;
};

Auth = _objectSpread(_objectSpread(_objectSpread({}, Auth), session), multiSession);
module.exports = Auth;